function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-006284b8-9b0f-4d21-b95b-0e3dbe0e6a1f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m23.232,9.06c-1.323-.825-2.277-2.187-2.557-3.782-.027-.152-.047-.306-.061-.46v-.515h-4.029v15.992c-.007,1.864-1.52,3.374-3.387,3.374-.548,0-1.065-.13-1.524-.361-1.105-.558-1.863-1.702-1.863-3.024,0-1.869,1.516-3.385,3.387-3.385.358,0,.704.056,1.028.158v-4.093c-.337-.046-.676-.069-1.016-.069-4.09,0-7.405,3.314-7.405,7.401,0,2.562,1.302,4.819,3.282,6.148,0,0,0,0,0,0,1.178.791,2.597,1.252,4.122,1.252,4.089,0,7.404-3.313,7.404-7.401v-8.171c1.574,1.124,3.501,1.785,5.583,1.785v-4.004c-1.048.002-2.075-.292-2.964-.846Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.325c80cc1b2e7dc320afa8ffdc705424.svg";
export { ForwardRef as ReactComponent };